import { EditorExtensionEnum as e } from "../enums/editor-extensions-enum.mjs";
import { BlockImage as t } from "../extensions/image-extension/block-image.mjs";
import { InlineImage as n } from "../extensions/image-extension/inline-image.mjs";
import { FontFamily as r } from "../extensions/font-family-extension/index.mjs";
import { createFontSizeExtension as i } from "../extensions/font-size-extension/index.mjs";
import { HeadingExtension as a } from "../extensions/heading-extension/index.mjs";
import { Indent as o } from "../extensions/indent-extension/indent.mjs";
import { LineHeightExtension as s } from "../extensions/line-height-extension/index.mjs";
import { createLinkExtension as c, createSimpleLinkExtension as l } from "../extensions/link-extension/index.mjs";
import { BulletListExtension as u, ListItemExtension as d, OrderedListExtension as f } from "../extensions/list-extension/list-extension.mjs";
import { ParagraphExtension as p } from "../extensions/paragraph-extension/index.mjs";
import { TextAlignExtension as m } from "../extensions/text-align-extension/index.mjs";
import { TextBackgroundColor as h } from "../extensions/text-background-color-extension/index.mjs";
import { TextColor as g } from "../extensions/text-color-extension/index.mjs";
import { HardBreakExtension as _, SimpleHardBreakExtension as v } from "../extensions/hard-break-extension/index.mjs";
import { TextStyle as y } from "../extensions/text-style-extension/index.mjs";
import { CharacterCount as b, Dropcursor as x, UndoRedo as S } from "@tiptap/extensions";
import { Bold as C } from "@tiptap/extension-bold";
import { Document as w } from "@tiptap/extension-document";
import { Italic as T } from "@tiptap/extension-italic";
import { Strike as E } from "@tiptap/extension-strike";
import { Text as D } from "@tiptap/extension-text";
import { Underline as O } from "@tiptap/extension-underline";
//#region src/utils/get-extensions.ts
var k = (k, A) => {
	let j = {
		[e.Document]: w,
		[e.Paragraph]: p,
		[e.Text]: D,
		[e.TextStyle]: y,
		[e.FontFamily]: r,
		[e.Heading]: a,
		[e.Bold]: C,
		[e.Italic]: T,
		[e.Strike]: E,
		[e.Underline]: O,
		[e.BulletList]: u,
		[e.OrderedList]: f,
		[e.ListItem]: d,
		[e.TextAlign]: m,
		[e.Link]: c(A?.[e.Link]),
		[e.SimpleLink]: l(A?.[e.Link]),
		[e.History]: S,
		[e.TextColor]: g,
		[e.TextBackgroundColor]: h,
		[e.FontSize]: i(A?.[e.FontSize]),
		[e.LineHeight]: s,
		[e.Indent]: o,
		[e.HardBreak]: _,
		[e.SimpleHardBreak]: v,
		[e.Substitution]: null,
		[e.SpecialCharacters]: null,
		[e.Image]: [t.configure(A?.[e.Image]), n.configure(A?.[e.Image])],
		[e.DropCursor]: x,
		[e.CharacterCount]: b
	};
	return k.flatMap((e) => {
		let t = j[e];
		return Array.isArray(t) ? t : [t];
	}).filter((e) => e !== null);
}, A = (t) => Object.values(e).reduce((n, r) => ({
	...n,
	[`has${e[r]}`]: t.includes(r)
}), {});
//#endregion
export { A as getExistingExtensions, k as getExtensions };
